import { render, staticRenderFns } from "./ContactDetailsLink.vue?vue&type=template&id=7f9fa3ce&"
import script from "./ContactDetailsLink.vue?vue&type=script&lang=js&"
export * from "./ContactDetailsLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports